// extracted by mini-css-extract-plugin
module.exports = {"table":"_3nBDSm","dataRow":"jgvzYH","noWithdrawals":"_1gC1lO"};